import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import BodyOverflow from '../BodyOverflow';
import { Icon } from '../Icon';
import { modalContainer, modalScrollContainer, modalContentContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Modal = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      _props$show = props.show,
      show = _props$show === void 0 ? false : _props$show,
      withoutClose = props.withoutClose,
      closeIcon = props.closeIcon,
      onClose = props.onClose,
      onOpen = props.onOpen,
      className = props.className;

  var _useState = useState(show),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  useImperativeHandle(ref, function () {
    return {
      open: function open() {
        return _open();
      },
      close: function close() {
        return _close();
      }
    };
  });
  useEffect(function () {
    if (withoutClose) return;

    var handleKeyDown = function handleKeyDown(e) {
      return (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) && _close();
    };

    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  useEffect(function () {
    show ? document.body.style.setProperty('overflow', 'hidden') : document.body.style.removeProperty('overflow');
    setShowModal(show);
  }, [show]);

  var _close = function _close() {
    _isFunction(onClose) && onClose();
    setShowModal(false);
  };

  var _open = function _open() {
    _isFunction(onOpen) && onOpen();
    setShowModal(true);
  };

  return showModal && ___EmotionJSX(BodyOverflow, {
    fixed: true,
    fullScreen: true,
    css: modalContainer,
    zIndex: 1000,
    onClick: _close
  }, ___EmotionJSX("section", _extends({
    css: modalScrollContainer(props)
  }, className && {
    className: className
  }), ___EmotionJSX("div", {
    role: "presentation",
    css: modalContentContainer(props),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, closeIcon !== null && closeIcon !== void 0 ? closeIcon : ___EmotionJSX(Icon, {
    iconName: "las la-times",
    size: 20,
    position: "absolute",
    top: "2rem",
    right: "2rem",
    onClick: _close
  }), children)));
});
Modal.propTypes = {
  children: PropTypes.any,
  show: PropTypes.bool,
  withoutClose: PropTypes.bool,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  className: PropTypes.string,
  closeIcon: PropTypes.any
};
export default Modal;